var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM17.5453 7.51497C17.8297 7.21383 17.8161 6.73915 17.515 6.45474C17.2138 6.17033 16.7392 6.18389 16.4547 6.48503L15.6767 7.30882H9C8.79365 7.30882 8.59642 7.39384 8.45474 7.54386L6.45474 9.6615C6.17033 9.96264 6.18389 10.4373 6.48503 10.7217C6.78617 11.0061 7.26085 10.9926 7.54526 10.6914L9.32329 8.80882H10.0561L9.50976 14.0148C9.43921 14.6871 8.83147 15.25 8.04447 15.25H7.27778C6.86356 15.25 6.52778 15.5858 6.52778 16C6.52778 16.4142 6.86356 16.75 7.27778 16.75H8.04447C9.54082 16.75 10.8449 15.6641 11.0016 14.1713L11.5643 8.80882H12.8624L12.4775 14.3102C12.3826 15.6673 13.5046 16.75 14.8333 16.75C16.1028 16.75 17.1944 15.7605 17.1944 14.4646V13.8824C17.1944 13.4681 16.8587 13.1324 16.4444 13.1324C16.0302 13.1324 15.6944 13.4681 15.6944 13.8824V14.4646C15.6944 14.8647 15.3434 15.25 14.8333 15.25C14.2979 15.25 13.9448 14.8301 13.9738 14.4149L14.366 8.80882H16C16.2063 8.80882 16.4036 8.72381 16.5453 8.57379L17.5453 7.51497Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiAlt);
export default __webpack_public_path__ + "static/media/pi-alt.771c4b31cb227a25add4b80bfbc10daf.svg";
export { ForwardRef as ReactComponent };